import React from "react";
import { ResponsivePie } from "@nivo/pie";
import { Box } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";

export default function ChartPieT2({ data }) {
  const [convertData, setConvertData] = useState([]);
  let last = [];

  useEffect(() => {
    if (data && data.length > 0) {
      const tsData = data.filter((item) => item.inoutFlag === "T");
      const inData = data.filter((item) => item.inoutFlag === "I");
      const outData = data.filter((item) => item.inoutFlag === "E");
      const tsWeight = tsData.reduce((sum, item) => sum + item.weight, 0);
      const inWeight = inData.reduce((sum, item) => sum + item.weight, 0);
      const outWeight = outData.reduce((sum, item) => sum + item.weight, 0);

      const tsWeight2 = tsWeight.toFixed(0);
      const inWeight2 = inWeight.toFixed(0);
      const outWeight2 = outWeight.toFixed(0);
      last = [
        {
          id: "환적",
          label: "환적",
          value: tsWeight2,
          color: "hsl(166, 70%, 50%)",
        },
        {
          id: "수입",
          label: "수입",
          value: inWeight2,
          color: "hsl(166, 70%, 50%)",
        },
        {
          id: "수출",
          label: "수출",
          value: outWeight2,
          color: "hsl(166, 70%, 50%)",
        },
      ];

      setConvertData(last);
    }
  });
  return (
    <ResponsivePie
      data={convertData}
      margin={{ top: 10, right: 10, bottom: 25, left: 10 }}
      innerRadius={0.3}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={7}
      borderWidth={3}
      borderColor={"#ffffff"}
      tooltip={({ datum }) => (
        <div
          style={{
            background: "#fff",
            padding: "5px",
            border: "1px solid #ccc",
          }}
        >
          <strong>{datum.id}</strong>: {datum.value}
        </div>
      )}
      enableArcLinkLabels={false}
      defs={[
        {
          id: "a",
          type: "patternLines",
          color: "#264E49",
          background: "#264E49",
          padding: 1,
        },
        {
          id: "b",
          type: "patternLines",
          color: "#ff6666",
          background: "#ff6666",
          padding: 1,
        },
        {
          id: "c",
          type: "patternLines",
          color: "#009999",
          background: "#009999",
          padding: 1,
        },
      ]}
      fill={[
        {
          match: {
            id: "수입",
          },
          id: "a",
        },
        {
          match: {
            id: "수출",
          },
          id: "b",
        },
        {
          match: {
            id: "환적",
          },
          id: "c",
        },
      ]}
      arcLabel={(e) => e.id + " (" + e.value + ")"}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#ffffff"
      arcLinkLabelsThickness={4}
      arcLinkLabelsStraightLength={5}
      arcLinkLabelsTextOffset={0}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [["brighter", 3]],
      }}
    />
  );
}
